import { createContext, useContext } from "react";

import { EMPTY_PROFILE } from "./helpers";
import type { DemoSeedProfile } from "./types";

export const DemoSeedProfileContext =
  createContext<DemoSeedProfile>(EMPTY_PROFILE);

export function useDemoSeedProfile(): DemoSeedProfile {
  return useContext(DemoSeedProfileContext);
}
